import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * YİNELEME ANAHTARLARI — DİYALOĞUN ÖMRÜNDEN UZUN (T4 QA P2-1).
 *
 * Kusur: anahtar diyaloğun yerel durumundaydı. Yanıt kopunca personel
 * diyaloğu kapatıp açıyor, aynı bilgilerle yeniden gönderiyor ve YENİ anahtar
 * gidiyordu; sunucu bunu yeni istek sayıp ikinci krediyi yazıyordu.
 *
 * Kural: anahtar KAPSAMA (işlem + kurum, ters kayıtta hak) ve GÖVDE PARMAK
 * İZİNE bağlıdır ve depoda yaşar. Aynı kapsam ve aynı gövde, kesin bir yanıt
 * gelene kadar AYNI anahtarla gider (kapat-aç dahil). Başarı ya da kesin ret
 * anahtarı bırakır, gövde değişimi yenisini üretir. Oturum sınırında depo
 * sıfırlandığı için anahtar başka bir personele geçmez.
 */
export interface WriteKeyEntry {
  readonly signature: string;
  readonly key: string;
}

export type WriteKeysState = Record<string, WriteKeyEntry>;

const initialState: WriteKeysState = {};

const slice = createSlice({
  name: 'panelWriteKeys',
  initialState,
  reducers: {
    writeKeyIssued(state, action: PayloadAction<{ scope: string } & WriteKeyEntry>) {
      state[action.payload.scope] = {
        signature: action.payload.signature,
        key: action.payload.key,
      };
    },
    writeKeyReleased(state, action: PayloadAction<string>) {
      delete state[action.payload];
    },
  },
});

export const { writeKeyIssued, writeKeyReleased } = slice.actions;
export const writeKeysReducer = slice.reducer;
